import React from "react"
import styled, {css} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {useBudgetsList} from "@irati/wallet/hooks/budget"
import {Budget} from "@irati/types"

const BarWidget = styled.div`
  width: 100%;
  height: 24px;
  outline: thin solid ${({theme}) => theme.colors.greys.mediumLight};
  border-radius: ${({theme}) => theme.border.radius.small};
`

interface IBlock {
  w: number
  c: string
  first?: boolean
  last?: boolean
}

const Block = styled.span.attrs<IBlock>(({w}) => ({
  style: {
    width: `${w}%`
  }
}))<IBlock>`
  display: inline-block;
  height: 100%;
  ${({c, first, last, theme}) => css`
    background: ${c};
    ${first &&
    css`
      border-top-left-radius: ${theme.border.radius.small};
      border-bottom-left-radius: ${theme.border.radius.small};
    `}

    ${last &&
    css`
      border-top-right-radius: ${theme.border.radius.small};
      border-bottom-right-radius: ${theme.border.radius.small};
    `}
  `}
`

type BudgetBarCategory = Pick<Budget, "name" | "uuid" | "metadata" | "percentage">

export interface BudgetBarCategories {
  unassigned?: BudgetBarCategory
  categories?: BudgetBarCategory[]
}

export default function BudgetBar(budgets: BudgetBarCategories) {
  const {data} = useBudgetsList()
  const theme = useTheme()

  if (!data) return null

  const unassigned = budgets.unassigned ?? data.budgets.unassigned
  const categories = budgets.categories ?? data.budgets.categories

  const unassignedBlock = {
    ...unassigned,
    color: theme.colors.greys.light
  }
  return (
    <div aria-hidden>
      <BarWidget>
        {[...categories, unassignedBlock].map((c, i, arr) => (
          <Block key={c.uuid} w={c.percentage} c={c.metadata.color} first={i === 0} last={c === arr.at(-1)} />
        ))}
      </BarWidget>
      <Flex justifyContent="space-between">
        <Body small>0%</Body>
        <Body small>100%</Body>
      </Flex>
    </div>
  )
}
